import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

export interface CustomFieldDefinitionDocument extends BaseDocument {
  name: string
  fieldType: 'string' | 'number' | 'date' | 'list'
  sortOrder: string | null
  isRequired: boolean
  customFieldTabId: string
  customFieldGroupId: string | null
  config: string | null
  workItemTypeIds: Array<string>
  projectIds: Array<string>
  options: string | null
}

const hooks = createEntityHooks<CustomFieldDefinitionDocument>('customfielddefinitions')

export const useCustomFieldDefinitions = (filter?: Partial<CustomFieldDefinitionDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { customFieldDefinitions: data, isLoading, db }
}

export const useCustomFieldDefinition = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { customFieldDefinition: data, isLoading }
}

export const useCustomFieldDefinitionMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createCustomFieldDefinition: create,
    updateCustomFieldDefinition: update,
    deleteCustomFieldDefinition: deleteEntity,
  }
}
